import script from "./SubscribeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeButton.vue?vue&type=style&index=0&id=797e96bc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797e96bc"]])

export default __exports__